import { ImageOff } from "lucide-react";
import { TileIconWrap, TileIconFallback } from "./styles.tileIcon";

export default function TileIcon({ src, onError, mobileSize = "64px", children }) {
  return (
    <TileIconWrap $mobileSize={mobileSize}>
      {src ? (
        <img src={src} alt="" onError={onError} />
      ) : (
        <TileIconFallback>
          <ImageOff size={mobileSize} strokeWidth={2} />
        </TileIconFallback>
      )}
      {children}
    </TileIconWrap>
  );
}
